// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Icon from "components/global/Icon";

// #####################################################

export const StyledDropdownButtonIcon = styled(
	({ isInsideDropdownMenu, ...props }) => <Icon {...props} />
)`
	display: flex;
	font-size: 14px;
	cursor: pointer;

	${({ isInsideDropdownMenu }) =>
		isInsideDropdownMenu &&
		css`
			padding: 0.75rem 1rem;
		`}
`;

// #####################################################
